import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAdmin } from "../../store/slices/authSlice";
import "./Unauthorized.css";

const Unauthorized = () => {
  const navigate = useNavigate();
  const isAdmin = useSelector(selectIsAdmin);

  const handleGoBack = () => {
    // Navigate based on role
    if (isAdmin) {
      navigate("/admin/dashboard");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <div className="unauthorized-icon">🔒</div>
        <h1 className="unauthorized-title">Access Denied</h1>
        <p className="unauthorized-message">
          You don't have permission to access this page.
        </p>
        <p className="unauthorized-hint">
          This page requires admin privileges.
        </p>
        <div className="unauthorized-actions">
          <button onClick={handleGoBack} className="btn-primary">
            Go to Dashboard
          </button>
          <button onClick={() => navigate(-1)} className="btn-secondary">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
